/* eslint-disable no-underscore-dangle */
import { fabric, LayerManager, eventStatus } from '@aibee/vincent';

const min = fabric.util.array.min;
const max = fabric.util.array.max;

function insertPointDict(result, shape) {
  let points = [];
  if (shape.type === 'CommonLine') {
    points = shape.rels.map(item => ({ x: item.left, y: item.top, uuid: item.uuid }));
  } if (shape.type === 'CirclePoint') {
    points = [{ x: shape.left, y: shape.top, uuid: shape.uuid }];
  } else if (['Elevator', 'Escalator', 'Screen', 'PanoramaPoint'].includes(shape.type)) {
    points = [{ x: shape.left, y: shape.top, uuid: shape.uuid }];
  } else if (shape._objects) {
    const objects = shape.getObjects();
    const pointObjects = objects.filter(item => item.type === 'CirclePoint');
    points = pointObjects.map(item => ({ x: item.left, y: item.top, uuid: item.uuid }));
  }

  const graphic_data = points.map((point) => {
    const existKey = Object.keys(result.point_dict).find((key) => {
      const existPoint = result.point_dict[key];
      return (existPoint.x === point.x) && (existPoint.y === point.y);
    });
    if (existKey > -1) return existKey;
    result.point_dict[point.uuid] = point;

    return point.uuid;
  });
  return graphic_data;
}
export function dataExporter() {
  const allLayers = LayerManager.getAllLayers();
  // 导出结果数据
  const result = {
    point_dict: {}, // 所有位置点数据，map类型 uuid:{x,y}
    /**
     * graphic_id: 图像id
     * graphic_type: 对外使用的类型 point line polygon
     * graphic_data: [] 数组，对应point_dict的key
     * property: {} 图像属性
     * group_id: 分组id
     * group_type: 内部图形类型
     * sequence_id: 如果是分组类型，内部图形顺序
     */
    graphic_list: [],
    image_url: '', // 底图url
  };

  const typeValueMap = {
    Elevator: '2',
    Escalator: '2',
    Screen: '4',
    PanoramaPoint: '91',
  };

  allLayers.forEach((layer) => {
    // const layer = layer.getLayerData();
    // 转换对外类型
    const typeMap = {
      CirclePoint: 'point',
      CommonLine: 'line',
      SkeletonPolygon: 'polygon',
    };
    const allObject = layer.getAllObjects();
    allObject.forEach((item) => {
      if (item.property && item.type === 'CirclePoint' && !item.property.type) {
        item.property.type = '0';
      }
      if (item.type === 'BgImage') {
        // TODO BgImage修改渲染方式
        result.image_url = item.src;
      } else if (!item.groupType && item.type !== 'BgImage' && typeMap[item.type] && !item.isGroup) {
        const rels = item.rels.map(rel => rel.uuid);
        const shapeData = {
          graphic_id: item.uuid,
          graphic_type: typeMap[item.type],
          graphic_data: insertPointDict(result, item),
          property: item.property,
        };
        result.graphic_list.push(shapeData);
      } else if (item.type === 'LinePoint') {
        item._objects.forEach((child, childIndex) => {
          const rels = item.rels.map(rel => rel.uuid);
          const shapeData = {
            graphic_id: child.uuid,
            graphic_type: typeMap[child.type],
            graphic_data: insertPointDict(result, child),
            property: child.property,
            group_id: item.uuid,
            group_type: 'LinePoint',
            sequence_id: childIndex,
          };
          result.graphic_list.push(shapeData);
        });
      } else if (['Elevator', 'Escalator', 'Screen', 'PanoramaPoint'].includes(item.type) && item.uuid) {
        result.point_dict[item.uuid] = { x: item.left, y: item.top, uuid: item.uuid };
        item.property.type = typeValueMap[item.type];
        const shapeData = {
          graphic_id: item.uuid,
          graphic_type: 'point',
          graphic_data: [item.uuid],
          property: item.property,
          group_id: item.uuid,
          group_type: item.type,
        };
        result.graphic_list.push(shapeData);
      }
    });
  });
  return result;
}

export default {
  dataExporter,
  // dataImporter,
};
